module.exports = __webpack_public_path__ + "img/frank-neuschaefer.6aca8abe.jpg";